import {
  PROPOSTA_SITUACAO,
  ProposalTypeValue
} from "@repo/core/services/entities/Proposals";

export type ProposalEffectuationFlow =
  | "creditForm"
  | "fidelityForm"
  | "effectuate"
  | "unmapped";

export const isProposalEffectuationProcessingStatus = (
  status: string | number | undefined | null
): boolean => {
  const normalizedStatus =
    status === undefined || status === null
      ? ""
      : String(status).padStart(2, "0");

  return (
    normalizedStatus === PROPOSTA_SITUACAO.QUEUE_ANALYSIS_AUTOMATIC ||
    normalizedStatus === PROPOSTA_SITUACAO.WAITING_FOR_ANALYSIS ||
    normalizedStatus === PROPOSTA_SITUACAO.ANALYSIS_AUTOMATIC
  );
};

export const getProposalEffectuationFlow = (
  status: string | undefined,
  proposalType?: ProposalTypeValue
): ProposalEffectuationFlow => {
  void proposalType;

  switch (status) {
    case PROPOSTA_SITUACAO.PRE_PROPOSAL_APPROVED:
      return "creditForm";

    case PROPOSTA_SITUACAO.PRE_PROPOSAL_REJECTED:
    case PROPOSTA_SITUACAO.REJECTED_AUTOMATICALLY:
    case PROPOSTA_SITUACAO.REJECTED_MANUALLY:
      return "fidelityForm";

    case PROPOSTA_SITUACAO.APPROVED_AUTOMATICALLY:
      return "effectuate";

    case PROPOSTA_SITUACAO.APPROVED_MANUALLY:
      return "effectuate";

    default:
      return "unmapped";
  }
};
